<template>
  <div v-if="info.proof">
    <h4 class="stl_header">
        <img src="https://api.dianzibiaopai.top/public/content/logo/logoBig.png" style="max-width:45px;margin-top:5px"/>酒钢集团</h4>
    <h4 class="stl_scrlApp">批板卷基本信息</h4>
    <div class="stl_appDiv" id="appDiv">
        <table class="stl_table" cellpadding="0" cellspacing="0" width="100%" >
            <tr>
                <td class="table_title">质证书编号：</td>
                <td class="table_intro" id="millSheetNo"> {{ info.licence }} </td>
            </tr>
            <tr>
                <td class="table_title">收货单位：</td>
                <td class="table_intro" id="name">{{ info.recipient }}</td>
            </tr>
            <tr>
                <td class="table_title">产品名称：</td>
                <td class="table_intro" id="zcpmc">{{ info.name }}</td>
            </tr>
            <tr>
                <td class="table_title">牌号：</td>
                <td class="table_intro" id="zph">{{ info.brand }}</td>
            </tr>
            <tr>
                <td class="table_title">标准：</td>
                <td class="table_intro" id="zzxbz">{{ info.standards }}</td>
            </tr>
            <tr>
                <td class="table_title">车号：</td>
                <td class="table_intro" id="zchehao">{{info.licensePlate}}</td>
            </tr>
            <tr>
                <td class="table_title">到站：</td>
                <td class="table_intro" id="zdaozhan">{{info.arrive}}</td>
            </tr>
            <!--<tr>
                <td class="table_title">重量：</td>
                <td class="table_intro" id="">BJJ-金州</td>
            </tr>-->
            <tr>
                <td class="table_title">交货状态：</td>
                <td class="table_intro" id="zjhzt">{{info.state}}</td>
            </tr>

        </table>
    </div>
    <h4 class="stl_scrlDetail">明细列表</h4>
    <div v-html="info.proof" class="chemistry-table stl_table" id="stl_table"></div>
   
  </div>
</template>

<script>
export default {
    props:['info'],
    mounted(){
        // document.documentElement.style.fontSize = 2 * window.innerWidth / 7.5 + 'px';
    }
}
</script>

<style scoped>
 .stl_header {
    position: fixed;
    top: 0;
    height: 50px;
    line-height: 50px;
    margin: 0;
    padding: 0 10px;
    background: #3881dd;
    width: 100%;
    color: #fff;
    z-index: 1000;
    font-weight: bold;
    font-size: 16px;
}

.stl_header img {
    display: block;
    float: left;
    padding: 4px;
}

.stl_scrlApp {
    color: #fff;
    background-color: #3881dd;
    height: 36px;
    line-height: 36px;
    margin: 50px 0 0 0;
    padding: 0 10px;
    border-top: 1px solid #fff;
    font-weight: bold;
    font-size: 16px;
}

.stl_appDiv {
    width: 100%;
    padding: 0;
}

.stl_scrlDetail {
    color: #fff;
    background-color: #3881dd;
    height: 36px;
    line-height: 36px;
    padding: 0 10px;
    margin: 0;
    font-weight: bold;
    font-size: 16px;

}
.stl_DivDetail {
    width: 100%;
    padding: 0;
}
/deep/ .stl_table table{
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
}
/deep/ .stl_table table tr td:first-child{
    width: 120px;
    text-align: right;
    font-size: 14px;
    background: #eee;
    margin-right: 10px;
}
/deep/ .stl_table table tr td:last-child{
    padding: 0 15px;
    font-size: 14px;
}
/deep/ .stl_table td{
    min-height: 36px;
    line-height: 36px;
    border: 1px solid #e4e4e4;
}
.table_title{
    width: 120px;
    text-align: right;
    font-size: 14px;
    background: #eee;
    margin-right: 10px;
}
.table_intro{
    padding: 0 15px;
    font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/man3/zs.vue